import type { CandidatureResume } from '@rh/shared';
import { libelleSource } from './format';

/** Tri commun à la liste par annonce et à la recherche par mot-clé. */
export type Tri = 'defaut' | 'note' | 'pastille' | 'site' | 'reception';

export const TRIS: readonly Tri[] = ['defaut', 'note', 'pastille', 'site', 'reception'];

export const LIBELLES_TRI: Record<Tri, string> = {
  defaut: 'Adéquation (par défaut)',
  // Note d'entretien : celle du barème, figée après le présentiel (docs/BAREME.md).
  note: 'Note d’entretien, plus haute d’abord',
  pastille: 'Pastille, plus haute d’abord',
  site: 'Site annonceur',
  reception: 'Réception, plus récente d’abord',
};

/**
 * « defaut » garde l'ordre rendu par l'API (adéquation puis réception sur une
 * liste d'annonce, réception seule dans la recherche) ; les autres trient une
 * copie, à égalité dans cet ordre-là. Les candidats sans note ni pastille
 * passent en dernier, jamais devant un 0.
 */
export function trier(liste: readonly CandidatureResume[], tri: Tri): CandidatureResume[] {
  if (tri === 'defaut') return [...liste];
  const rang = new Map(liste.map((c, i) => [c.id, i]));
  const egalite = (a: CandidatureResume, b: CandidatureResume) => rang.get(a.id)! - rang.get(b.id)!;
  const copie = [...liste];
  if (tri === 'site') {
    copie.sort((a, b) => libelleSource(a.source).localeCompare(libelleSource(b.source), 'fr') || egalite(a, b));
  } else if (tri === 'reception') {
    copie.sort((a, b) => b.recueLe.localeCompare(a.recueLe) || egalite(a, b));
  } else if (tri === 'note') {
    copie.sort((a, b) => (b.noteEntretien ?? -1) - (a.noteEntretien ?? -1) || egalite(a, b));
  } else {
    copie.sort((a, b) => (b.potentiel ?? -1) - (a.potentiel ?? -1) || egalite(a, b));
  }
  return copie;
}
